exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title {\n  font-size: 18px;\n  text-align: center;\n  margin-top: 0px;\n  padding-top: 5px; }\n", "", {"version":3,"sources":["/usr/src/app/src/routes/administrator/components/add-new-district/AddNewDistrict.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB,EAAE","file":"AddNewDistrict.scss","sourcesContent":[".title {\n  font-size: 18px;\n  text-align: center;\n  margin-top: 0px;\n  padding-top: 5px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./routes/administrator/components/add-new-district/AddNewDistrict.scss
// module id = 1773
// module chunks = 0